import { UPDATE_IP_ADDRESS } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_IP_ADDRESS:
            return action.payload
        default:
            return state
    }
}
